import { render, staticRenderFns } from "./templateCard.vue?vue&type=template&id=6c136fc6&scoped=true"
import script from "./templateCard.vue?vue&type=script&lang=js"
export * from "./templateCard.vue?vue&type=script&lang=js"
import style0 from "./templateCard.vue?vue&type=style&index=0&id=6c136fc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3_jycg54st5iyjtzg36i6kaokove/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c136fc6",
  null
  
)

export default component.exports